import { Spin } from "antd";
import { FC } from "react";

export const Spinner: FC = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
    <Spin size="large" tip="Loading, please wait..." />
  </div>
);
